import { AxiosResponse } from "axios";
import { axiosInstance } from "@/plugins/axios";

export default class AutocompleteApi {
  public static async findAutocomplete(
    baseUrl: string,
    search: string,
    query: string
  ): Promise<AxiosResponse> {
    if (search != null) {
      const response: AxiosResponse = await axiosInstance.get(
        baseUrl +
          "/autocomplete?" +
          "search=" +
          encodeURIComponent(search) +
          "&" +
          // encodeURIComponent(query)
          query
      );
      return response;
    } else {
      const response: AxiosResponse = await axiosInstance.get(
        baseUrl +
          "/autocomplete?" +
          "&" +
          //encodeURIComponent(query)
          query
      );
      return response;
    }
  }
}
